export default __webpack_public_path__ + "static/media/illegal-moves.bbb6cee1.yaml";